import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Send, Loader2 } from "lucide-react";

export async function publishTelegram({ text = "", imageId = "", blobs = [] }) {
  const fd = new FormData();
  fd.append("text", text);
  fd.append("image_id", imageId);
  blobs.forEach((b, i) => fd.append("files", b, `slide-${i + 1}.png`));
  const r = await api.post("/telegram/publish", fd, { timeout: 120000 });
  return r.data;
}

export function TelegramButton({ getPayload, testid, label = "Telegram", className }) {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const r = await publishTelegram(await getPayload());
      toast.success(`Pubblicato su Telegram (${r.chat})`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Pubblicazione su Telegram non riuscita");
    } finally { setBusy(false); }
  };
  return (
    <button onClick={send} disabled={busy} data-testid={testid}
      className={className || "flex items-center gap-1.5 text-xs px-2.5 py-1.5 rounded-lg bg-[#229ED9]/15 text-[#5cc0f0] hover:bg-[#229ED9]/25 transition-colors disabled:opacity-50"}>
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Send className="h-3.5 w-3.5" />} {busy ? "Invio…" : label}
    </button>
  );
}
